import { render, staticRenderFns } from "./meta-people-in-video-field.vue?vue&type=template&id=1847339a&scoped=true&"
import script from "./meta-people-in-video-field.vue?vue&type=script&lang=js&"
export * from "./meta-people-in-video-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1847339a",
  null
  
)

export default component.exports